import { Component } from '@angular/core';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import * as moment from 'moment';

import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';

import { LoginPage } from '../../pages/login/login';
import { HomePage } from '../../pages/home/home';
import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { CalendarComponentOptions } from 'ion2-calendar'
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { ListPage } from '../list/list';

@Component({
  selector: 'page-calendario',
  templateUrl: 'calendario.html'
})

export class CalendarioPage {
  
  diasdefiesta;
  myForm: FormGroup;
  myForm1: FormGroup;
 	fiestas: Array<{date: string, subTitle: string}>;
  selectedDay = new Date();
	eventSource;
  viewTitle;
  events;
  misapp: Array<{title: string, descripcion: string, imagen: string , component: any}>;
  formulario = {dia1: "",mes1: "",fiesta1: "", lugar1:""}
  resultado;
  date: string;
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  obras;

optionsRange: CalendarModalOptions = {
    color:'dark',
    weekStart:1,
    weekdays:['DO', 'LU', 'MA', 'MI', 'JU', 'VI', 'SA'],
    canBackwardsSelected: true,
    cssClass: 'font-size:6'

  };

  constructor(
    public fb: FormBuilder,
    public modalCtrl: ModalController,
  	public navCtrl: NavController,
    public funciones:FuncionesProvider,
  	public variables:VariablesProvider
    ) {

      this.variables.btatras = true;
      this.myForm = this.fb.group({

      dia: ['', [Validators.required]],
      mes: ['', [Validators.required]],
      fiesta: ['', [Validators.required]],
      lugar: ['', []],
     });

     this.myForm1 = this.fb.group({
      dia: [''],
      mes: [''],
      fiesta: [''],
      lugar: ['']
     });



    var fiestas = [];

   
    this.obtenerfiestas();

    this.funciones.obtieneobrasconfiltro("654321123456").then(
      data => {
  
      this.obras = data;
  
  
      }
  )
  .catch(
    error => {
      console.log(error);
    }
  )
  

  }

  onChange($event) {

    var cadena  = $event;

    this.formulario.dia1 = cadena.substr(8, 2);
    this.formulario.mes1 = cadena.substr(5, 2);
  }


  obtenerfiestas(){
    this.funciones.obtienefiestas().then(
          data => {
            this.diasdefiesta = data;
          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

  registro($event){

   if (this.formulario.lugar1==""){
    this.formulario.lugar1="Todos";

   }

   this.funciones.grabarfiesta(this.formulario.dia1, this.formulario.mes1, this.formulario.fiesta1, this.formulario.lugar1).then(
     data => {
          this.resultado = data;

          this.obtenerfiestas();

          this.formulario.dia1="";
          this.formulario.mes1="";
          this.formulario.fiesta1="";
          this.formulario.lugar1="";
          
        })

  }


  editarfiestas(index){
    
    for (var _i = 0; _i < this.diasdefiesta.length; _i++) {

      if (index==this.diasdefiesta[_i].ID) {

       // console.log(this.diasdefiesta[_i].ID + " - "  + this.diasdefiesta[_i].DIA + " - "  + this.diasdefiesta[_i].MES + " - "  + this.diasdefiesta[_i].NOMBRE + " - "  + this.diasdefiesta[_i].LUGAR);

        this.funciones.editafiesta(this.diasdefiesta[_i].ID , this.diasdefiesta[_i].DIA,    this.diasdefiesta[_i].MES ,   this.diasdefiesta[_i].NOMBRE ,  this.diasdefiesta[_i].LUGAR ).then(
          data => {
  
            //console.log(JSON.stringify(data));
    
  
          },
          err=>{
            console.log(err);
           }
  
          )
  
  






        }       
      }

  }  
  
  salir(){
    this.navCtrl.push(ListPage);
 }

   borrar(id){

     this.funciones.delfiesta(id).then(
         data => {
          this.resultado = data;
          this.obtenerfiestas();

        })
  }


  ponencampo(campo:string, value:string):void{
      
    switch (campo) {
       case "LUGAR":
         this.formulario.lugar1 = value;
     
         break;
     }
   
  }


  

 valChange(campo:string, value:string, index:number):void{
      
    for (var _i = 0; _i < this.diasdefiesta.length; _i++) {

      if (index==this.diasdefiesta[_i].ID) {
        switch (campo) {
          case "DIA":
            this.diasdefiesta[_i].DIA = value;
            break;
          case "MES":
            this.diasdefiesta[_i].MES = value;
            break;
          case "NOMBRE":
            this.diasdefiesta[_i].NOMBRE = value;
            break;
          case "LUGAR":
            this.diasdefiesta[_i].LUGAR = value;
            break;
        }       
      }

    }  
  
  
   
}


}



// WEBPACK FOOTER //
// ./src/pages/calendario/calendario.ts